var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCheckOrange16Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "13px",
    viewBox: "0 0 17 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-784.000000, -905.000000)",
    stroke: "#FFCD00",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(752.000000, 557.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.000000, 338.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "9 15.2857143 14.4545455 21 24 11"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckOrange16Px);
export default __webpack_public_path__ + "static/media/Icon_Check_Orange-16px.1c01bb1e5deaf69cb4c84b9171fc9357.svg";
export { ForwardRef as ReactComponent };